import React from 'react'
import { Link } from 'react-router-dom';
import { PencilIcon } from 'react-open-iconic-svg';

import Show                         from 'services/Show';
import { prepareUrl }               from 'services/DataSource';
import { showSearchStatePropTypes } from 'services/constants';
import { formatDate }               from 'services/utils';

import AbstractSearchableList from 'components/AbstractSearchableList';
import SearchFormComponent from 'components/ShowSearchForm';
import RemoveButton        from 'components/RemoveButton';

function ItemComponent({ item, collectionName, onRemove }) {
  function removeItem() {
    onRemove(item);
  }
  return (
    <div id={item.id} className="row border rounded pt-1 pb-1 mb-1 shadow-sm">
      <div className="col-1">
      <Link to={`/${collectionName}/${item.id}/edit`} className="btn btn-info m-2" title="редактировать">
        <PencilIcon className="icon" viewBox="0 0 8 8" alt="редактировать" />
      </Link>
      </div>
      <div className="col-11 col-md-8">
        <h5>
          <Link to={`/${collectionName}/${item.id}`} >{item.name}</Link> 
          <small className="ms-2">{formatDate(item.starts_at)}</small>
        </h5>
        <div>Регистрация {item.closed ? 'закрыта' : 'открыта'}</div>
        <Link to={`/${collectionName}/${item.id}/dogs`}>Собак зарегистрировано: {item.dogs_count}</Link><br/>
        <Link to={`/${collectionName}/${item.id}/experts`}>Эксперты: {item.invited_experts.length}</Link>, &nbsp;
        <Link to={`/${collectionName}/${item.id}/contests`}>Конкурсы</Link>, &nbsp;
        <Link to={`/${collectionName}/${item.id}/certificates`}>Сертификаты</Link>, &nbsp;
        <Link to={`/${collectionName}/${item.id}/diplomas`}>Дипломы</Link>, &nbsp;
        <a href={prepareUrl(`${collectionName}/${item.id}/reports/breeds.doc`)} >Породы.doc</a>, &nbsp;
        <a href={prepareUrl(`${collectionName}/${item.id}/reports/catalog.doc`)} >Каталог.doc</a>, &nbsp;
        <a href={prepareUrl(`${collectionName}/${item.id}/reports/show_dogs.csv`)} >Каталог.csv</a>
        {item.closed ? 
          <div>
            <Link to={`/${collectionName}/${item.id}/fcireport`}>заполнить отчёт FCI</Link>
            , &nbsp;<a href={prepareUrl(`shows/${item.id}/reports/fci_report.xls`)} >FCI_report.xls</a>
            , &nbsp;<Link to={`/${collectionName}/${item.id}/cruftsreport`}>заполнить отчёт CRUFTS</Link>
            , &nbsp;<a href={prepareUrl(`shows/${item.id}/reports/crufts_report.xls`)} >CRUFTS_report.xls</a>
          </div>
          : null 
        }
      </div>
      <RemoveButton className="col-1 btn-sm float-end ms-2" remove={removeItem} />
    </div>
  );
}


export default class Shows extends AbstractSearchableList {

  constructor(props) {
    super(props);
    this.itemClass = Show;
    this.itemName = 'show';
    this.collectionName = 'shows';
    this.collectionNameHuman = 'Выставки';
    this.Item = ItemComponent;
    this.SearchForm = SearchFormComponent;
    this.searchStatePropTypes = showSearchStatePropTypes;
  }

}
